import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuthContext } from '../../context/auth/auth'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import instance from '../api'
import { CURRENT_SUBSCRIPTION_QUERY_KEY } from './useCurrentSubscription'

const changePlan = async (
  subscriptionId: number,
  planId: number,
  token: string,
) => {
  return instance.post(
    `/payment/subscriptions/${subscriptionId}/change-plan/`,
    { pricing_plan_id: planId },
    { headers: { Authorization: `Bearer ${token}` } },
  )
}

const useChangePlan = () => {
  const { token } = useAuthContext()
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: ({
      subscriptionId,
      planId,
    }: {
      subscriptionId: number
      planId: number
    }) => changePlan(subscriptionId, planId, token!),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: CURRENT_SUBSCRIPTION_QUERY_KEY,
      })
      toast.success(t('planChangedSuccessfully'))
    },
    onError: (_) => {
      toast.error(t('failedToChangePlan'))
    },
  })
}

export default useChangePlan
